import axios from 'axios'

// O fallback so vale quando REACT_APP_API_URL nao foi injetada no build (ver
// config/config.env.*): aponta para producao para nao deixar a aplicacao sem API.
export const apiService = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://api.cartivia.com.br/',
})
